<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
  <div fxFlex>Delete {{ hasOnlyTranscription ? 'AI Recap' : 'Recording' }}</div>
  <button mat-icon-button [mat-dialog-close]="null" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography">
  <p>Are you sure you want to delete the selected {{ hasOnlyTranscription ? 'AI recap' : 'recording' }}?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="hasRecordingAndTranscription">
    <button
      type="button"
      mat-button
      color="primary"
      (click)="onDialogClose({ deleteRecording: true, deleteTranscription: true })"
      cdkFocusInitial
    >
      Delete Recording and AI Recap
    </button>
    <button
      type="button"
      mat-button
      color="primary"
      (click)="onDialogClose({ deleteRecording: true, deleteTranscription: false })"
      cdkFocusInitial
    >
      Delete Recording Only
    </button>
  </ng-container>
  <button
    *ngIf="hasOnlyRecording"
    type="button"
    mat-button
    color="primary"
    (click)="onDialogClose({ deleteRecording: true, deleteTranscription: false })"
    cdkFocusInitial
  >
    Delete Recording
  </button>
  <button
    *ngIf="hasOnlyTranscription"
    type="button"
    mat-button
    color="primary"
    (click)="onDialogClose({ deleteRecording: false, deleteTranscription: true })"
    cdkFocusInitial
  >
    Delete AI Recap
  </button>
</mat-dialog-actions>
